import { render, staticRenderFns } from "./DemoWait.vue?vue&type=template&id=2b62c3d4"
import script from "./DemoWait.vue?vue&type=script&lang=ts"
export * from "./DemoWait.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports